












import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { namespace } from 'vuex-class';

import Alert from '@/shared/components/Alert/Alert.vue';

import { ITraceableError } from '@/interfaces/Error';

import { EErrorExhibition, EErrorScope } from '@/helpers/enums';

const ErrorModule = namespace('App/Error');

@Component({
  components: {
    Alert
  }
})
export default class AlertErrors extends Vue {
  @ErrorModule.Getter('errorsByExhibitionAndScope')
  private errorsByExhibitionAndScope: Function;

  private get alerts() {
    const errors = this.errorsByExhibitionAndScope(EErrorExhibition.alert, [
      EErrorScope.global
    ]);

    return errors.filter((error: ITraceableError) => error.visibility);
  }
}
